import { atom } from "recoil";

export const prizeEditModalStore = atom({
	key: "prizeEditModalStore",
	default: {
		show: false,
		loaded: true,
		name: "",
		description: "",
		currentOption: {
			type: [
				{ value: "money", label: "Money" },
				{ value: "freespins", label: "Freespins" },
				{ value: "tickets", label: "Ticket" },
				{ value: "chest", label: "Chest" },
				{ value: "item", label: "Item" },
			],
			poolType: [
				{ value: "daily", label: "Daily" },
				{ value: "weekly", label: "Weekly" },
				{ value: "monthly", label: "Monthly" },
			],
		},
		icon: "",
		conditions: [],
		poolType: "",
		poolCount: "",
		rewardType: "",
		rewardValue: "",
		providerSelected: null,
		availableGames: [],
		gameSelected: null,
		betAmount: "",
		expiresAt: "",
		chestRewards: [],
		chestType: "",
		chestPrizeId: null,
		chestPrizeSelected: null,
		chestPrizeOptions: [],
		chestPrizeLoading: false,
		chestPrizeMatchMissing: false,
		hidden: false,
		showInBanner: false,
		image: null,
		probability: "",
		fakeWinsPerMonth: "",
		link: "",
		active: "",
	},
});
